import type { FeatureLink } from "services/cms/models/featureLink";
import type { ResolvedImage } from "./imageResolver";
import imageResolver from "./imageResolver";

export interface ResolvedFeatureLink {
    title: string;
    path: string;
    image: ResolvedImage;
}

const featureLinkResolver = (data: FeatureLink): ResolvedFeatureLink => {
    return {
        title: data.elements.title.value,
        path: data.elements.link.value,
        image: imageResolver(data.elements.image.linkedItems[0]),
    };
};

export default featureLinkResolver;
